import { Clock, XCircle, Building2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function PendingApproval({ portalLabel }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const declined = user?.tenant_status === "declined";

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6" data-testid="pending-approval-page">
      <div className="max-w-md text-center">
        <div className="flex items-center justify-center gap-2 text-slate-900 font-bold text-[15px] mb-8">
          <Building2 size={18} className="text-sky-500" /> ScapeSource
        </div>
        <div className={`w-14 h-14 rounded-2xl mx-auto flex items-center justify-center ${declined ? "bg-red-50" : "bg-amber-50"}`}>
          {declined ? <XCircle size={26} className="text-red-500" /> : <Clock size={26} className="text-amber-500" />}
        </div>
        <h1 className="text-xl font-extrabold tracking-tight mt-5" data-testid="pending-approval-title">
          {declined ? "Application Declined" : "Awaiting Approval"}
        </h1>
        <p className="text-slate-500 text-sm mt-2" data-testid="pending-approval-message">
          {declined
            ? "Your ScapeSource application was declined. If you believe this is a mistake, please contact ScapeSource support."
            : `Thanks for signing up! Your ${portalLabel} account is pending review by the ScapeSource team. You'll get a notification the moment you're approved.`}
        </p>
        <button onClick={handleLogout} data-testid="pending-logout-button" className="mt-6 px-4 py-2.5 rounded-lg border border-slate-200 text-[13px] font-semibold hover:bg-slate-50 transition-colors">
          Sign out
        </button>
      </div>
    </div>
  );
}
